// actions.js
import { createActions } from 'reduxsauce';

const { Creators, Types } = createActions({
    prepareContract: ['statuses'],
    onVerificationEvent: ['contractVerificationStatus'],
});

export default { Creators, Types };